const SOURCE_MAP: Record<string, string> = {
  direct: 'Direct',
  google: 'Google',
  adwords: 'Google',
  bing: 'Bing',
  linkedin: 'LinkedIn',
  facebook: 'Facebook',
  fb: 'Facebook',
  instagram: 'Instagram',
  ig: 'Instagram',
  twitter: 'X/Twitter',
  x: 'X/Twitter',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  reddit: 'Reddit',
  pinterest: 'Pinterest',
  snapchat: 'Snapchat',
};

const MEDIUM_MAP: Record<string, string> = {
  cpc: 'Paid Search',
  ppc: 'Paid Search',
  paidsearch: 'Paid Search',
  'paid-social': 'Paid Social',
  paid_social: 'Paid Social',
  paidsocial: 'Paid Social',
  social: 'Organic Social',
  'social-network': 'Organic Social',
  'social-media': 'Organic Social',
  sm: 'Organic Social',
  email: 'Email',
  edm: 'Email',
  newsletter: 'Email',
  affiliate: 'Affiliate',
  partner: 'Affiliate',
  referral: 'Referral',
  display: 'Display',
  banner: 'Display',
  cpm: 'Display',
  video: 'Video',
  cpv: 'Video',
  audio: 'Audio',
  podcast: 'Audio',
  sms: 'SMS',
  text: 'SMS',
  push: 'Push',
  'push-notification': 'Push',
  event: 'Event',
  conference: 'Event',
  tradeshow: 'Event',
  meetup: 'Event',
  webinar: 'Event',
  offline: 'Offline',
  print: 'Offline',
  qr: 'Offline',
  billboard: 'Offline',
  none: 'Unknown',
  '(none)': 'Unknown',
};

const resolveLabel = (
  value: string | undefined,
  map: Record<string, string>,
  fallback = 'Unknown'
) => {
  if (!value) return fallback;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return fallback;
  return map[normalized] ?? value.trim();
};

export const formatSourceLabel = (utmSource?: string, utmMedium?: string) => {
  const source = resolveLabel(utmSource, SOURCE_MAP, 'Direct');
  const medium = resolveLabel(utmMedium, MEDIUM_MAP);
  if (source === 'Direct' && medium === 'Unknown') {
    return 'Direct';
  }
  return `${source} / ${medium}`;
};
